import React, { useState } from 'react';

const HiddenText = ({service,lang}) => {
    const [show, setShow] = useState(false);

    return (
        <div  style={{minHeight:'90px', display: lang=='ru'&& !service.HiddenHtml?'none':lang=='uz'&& !service.HiddenHtmlUz?'none':''}}className={show?'resulthidden': 'resulthidden page-content catalog-text collapsed-main '} id="catalog-text">
            <div className="shorttext-text" dangerouslySetInnerHTML={{__html: lang=='ru'?service.HiddenHtml: lang=='uz'?service.HiddenHtmlUz:null }}>
            </div>
            <div className={show?'':'shorttext-button'} onClick={()=>{setShow(true);}}></div></div>
    );

};

export default HiddenText;